import { expect, aTimeout } from '@open-wc/testing';
import {
  executeServerCommand,
  sendKeys,
  sendMouse,
} from '@web/test-runner-commands';
import '../src/testHarness.js';
import {
  mockDataMeta,
  fixtureBeforeEach,
  fixtureBefore,
  fixtureAfterEach,
  TelemInfo,
  screenshotAndCompare,
} from './utils/helpers.js';

describe('notification item', () => {
  before(async () => {
    await fixtureBefore();
  });

  beforeEach(async () => {
    await fixtureBeforeEach();
  });

  afterEach(async () => {
    fixtureAfterEach();
  });

  it('should mark item as read and open, close and re-open a popover when the item is clicked', async () => {
    let readItemsInfo: TelemInfo[] = await executeServerCommand(
      'mouseFocusInfo',
      {
        selector: '[data-testclass="earlier-notification"][read]',
        action: 'info',
      }
    );

    const readItemsCount = readItemsInfo.length;

    expect(readItemsCount).to.equal(mockDataMeta.readCount);

    const lastItemPosition: [number, number] = await executeServerCommand(
      'mouseFocusInfo',
      {
        selector: '[data-testclass="earlier-notification"]:not([read])',
        action: 'mouse',
      }
    );

    await sendMouse({
      type: 'click',
      position: lastItemPosition,
    });

    let modalInfo: TelemInfo[] = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testclass="notification-modal"][open]',
      action: 'info',
    });

    expect(modalInfo.length).to.equal(1);

    await screenshotAndCompare('item-modal');

    readItemsInfo = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testclass="earlier-notification"][read]',
      action: 'info',
    });

    expect(readItemsInfo.length).to.equal(readItemsCount + 1);

    await executeServerCommand('mouseFocusInfo', {
      selector:
        '[data-testclass="notification-modal"][open] [data-testid="notification-view-item-close"]',
    });

    await sendKeys({
      press: 'Space',
    });

    await screenshotAndCompare('after-read-item-modal');

    modalInfo = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testclass="notification-modal"][open]',
      action: 'info',
    });

    expect(modalInfo.length).to.equal(0);

    await sendMouse({
      type: 'click',
      position: lastItemPosition,
    });

    modalInfo = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testclass="notification-modal"][open]',
      action: 'info',
    });

    expect(modalInfo.length).to.equal(1);

    // test toggling the modal off of the background to make sure it it re-opens
    await sendMouse({
      type: 'click',
      position: [100, 100],
    });

    await aTimeout(300);

    modalInfo = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testclass="notification-modal"][open]',
      action: 'info',
    });

    expect(modalInfo.length).to.equal(0);

    await sendMouse({
      type: 'click',
      position: lastItemPosition,
    });

    modalInfo = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testclass="notification-modal"][open]',
      action: 'info',
    });

    expect(modalInfo.length).to.equal(1);
  });
});
